/**
 * Common search utilities used across search components
 */

/**
 * Extracts query parameters from URL search string
 */
export const useQueryParams = (params: string): URLSearchParams => {
  return new URLSearchParams(params);
};

/**
 * Generic function to get search type from query string based on prefix map
 */
export const getSearchTypeFromQuery = <TSearchType extends string>(
  query: string,
  prefixMap: Record<string, TSearchType>,
  defaultType: TSearchType
): TSearchType => {
  const trimmedQuery = query.trim();
  for (const [prefix, searchType] of Object.entries(prefixMap)) {
    if (trimmedQuery.toLowerCase().startsWith(prefix.toLowerCase())) {
      return searchType;
    }
  }
  return defaultType;
};
